var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cell"},on:{"click":_vm.leftClick,"contextmenu":function($event){$event.preventDefault();return _vm.rightClick($event)}}},[_c(_vm.currentCell,{tag:"component",attrs:{"index":_vm.index,"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }